/**
 * Create user (admin): calls backend which forwards to create-user edge function.
 * Token is sent via Authorization header only (no token in body or query).
 * @typedef {import('../models/User').CreateUserRequest} CreateUserRequest
 */
import axios from 'axios';
import { authHeaders } from './apiAuth';

const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:8000';

/**
 * Create a new user (auth + profile + roles). Caller must be admin.
 * @param {string} accessToken - Caller's JWT (admin), sent in Authorization header
 * @param {CreateUserRequest} data - email, password, first_name?, last_name?, role_names
 * @returns {Promise<{ success: boolean, user_id?: string, error?: string }>}
 */
export const createUser = async (accessToken, data) => {
  try {
    const response = await axios.post(
      `${API_BASE_URL}/api/create-user`,
      {
        create_user: {
          email: data.email?.trim() || '',
          password: data.password,
          first_name: data.first_name?.trim() || null,
          last_name: data.last_name?.trim() || null,
          role_names: Array.isArray(data.role_names) ? data.role_names : [data.role_names]
        }
      },
      { headers: authHeaders(accessToken) }
    );
    return response.data;
  } catch (error) {
    const detail = error.response?.data?.detail;
    const msg = typeof detail === 'string' ? detail : detail?.message ?? error.message ?? 'Failed to create user';
    return { success: false, error: msg };
  }
};
